import omniStoreSegmentService from './reducers';

import * as omniStoreListOperation from './operation';
import * as omniStoreType from './types';
import * as omniStoreAction from './actions';

export { omniStoreListOperation, omniStoreType, omniStoreAction };

export default omniStoreSegmentService;
